/* shop5-address.js — address-first checkout handoff (WEB-03-B). */
(function () {
  'use strict';
  var cfg = window.shop5CheckoutConfig;
  if (!cfg || !cfg.token || !window.fetch || !window.Promise || !window.localStorage) return;

  var ADDRESS_KEY = 'shop5.address.v1';
  var SFCART_KEY = 'shop5.sfcart.v1';
  var PHONE_DIGITS = 8;
  var HANDOFF_TIMEOUT_MS = 8000;
  var COMPLETION_WINDOW_MS = 3 * 24 * 60 * 60 * 1000;
  var LANG = String(cfg.locale || 'ar').toLowerCase() === 'en' ? 'EN' : 'AR';
  var S = cfg.strings || {};
  var ENDPOINT = cfg.endpoint + '/api/' + (cfg.apiVersion || '2026-04') + '/graphql.json';

  /* ---------- helpers ---------- */
  function normalizeDigits(s) {
    var ar = '\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669';
    var fa = '\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9';
    return String(s || '').replace(/[\u0660-\u0669\u06F0-\u06F9]/g, function (ch) {
      var i = ar.indexOf(ch); if (i < 0) i = fa.indexOf(ch); return String(i);
    });
  }
  function phoneDigits(raw) {
    var d = normalizeDigits(raw).replace(/\D/g, '');
    if (d.indexOf('00974') === 0) d = d.slice(5);
    else if (d.indexOf('974') === 0 && d.length === 11) d = d.slice(3);
    return d;
  }
  function isValidPhone(d) { return d.length === PHONE_DIGITS; }
  function e164(d) { return '+974' + d; }
  function digitsOnly(s, max) { return normalizeDigits(s).replace(/\D/g, '').slice(0, max); }
  function splitName(name) {
    var n = String(name || '').trim();
    if (!n) return { firstName: '', lastName: '' };
    var i = n.indexOf(' ');
    if (i < 0) return { firstName: n, lastName: n };
    return { firstName: n.slice(0, i), lastName: n.slice(i + 1).trim() };
  }
  function composeAddress1(a) {
    if (a.address1) return a.address1;
    var parts = [];
    if (a.zone) parts.push('Zone ' + a.zone);
    if (a.street) parts.push('Street ' + a.street);
    if (a.building) parts.push('Building ' + a.building);
    return parts.length ? parts.join(', ') : a.city;
  }
  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }

  /* ---------- storage ---------- */
  function readAddress() {
    try {
      var raw = localStorage.getItem(ADDRESS_KEY);
      if (!raw) return null;
      var a = JSON.parse(raw);
      return (a && a.phone && a.city) ? a : null;
    } catch (e) { return null; }
  }
  function writeAddress(a) { try { localStorage.setItem(ADDRESS_KEY, JSON.stringify(a)); } catch (e) {} }
  function customerAddress() {
    var c = cfg.customer;
    if (!c || !c.address) return null;
    var d = phoneDigits(c.address.phone || c.phone || '');
    if (!isValidPhone(d)) return null;
    if (!c.address.city && !c.address.address1) return null;
    var nm = [c.address.firstName, c.address.lastName].filter(Boolean).join(' ') || c.name || '';
    return { name: nm, phone: e164(d), city: c.address.city || '', address1: c.address.address1 || '',
      zone: '', street: '', building: '', note: '', fromAccount: true };
  }
  function currentAddress() { return readAddress() || customerAddress(); }

  /* ---------- Storefront API ---------- */
  function sf(query, variables) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.errors && j.errors.length) throw new Error('graphql: ' + j.errors[0].message);
      return j.data || {};
    });
  }
  var CART_FIELDS = 'id checkoutUrl buyerIdentity { phone email countryCode } ' +
    'delivery { addresses { id selected address { ... on CartDeliveryAddress { address1 city phone countryCode } } } }';
  var Q_CART_CREATE = 'mutation shop5CartCreate($input: CartInput!, $lang: LanguageCode!) @inContext(language: $lang, country: QA) ' +
    '{ cartCreate(input: $input) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var Q_ADDR_ADD = 'mutation shop5AddrAdd($cartId: ID!, $addresses: [CartSelectableAddressInput!]!, $lang: LanguageCode!) @inContext(language: $lang, country: QA) ' +
    '{ cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) { cart { ' + CART_FIELDS + ' } userErrors { field message } } }';
  var Q_CART_READ = 'query shop5CartRead($id: ID!, $lang: LanguageCode!) @inContext(language: $lang, country: QA) ' +
    '{ cart(id: $id) { ' + CART_FIELDS + ' } }';

  function fetchThemeCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function buildLines(items) {
    return items.map(function (it) {
      var line = { merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id, quantity: it.quantity };
      var props = it.properties || {};
      var attrs = Object.keys(props).filter(function (k) {
        var v = props[k]; return v !== null && v !== '' && typeof v !== 'object';
      }).map(function (k) { return { key: k, value: String(props[k]) }; });
      if (attrs.length) line.attributes = attrs;
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id) {
        line.sellingPlanId = 'gid://shopify/SellingPlan/' + it.selling_plan_allocation.selling_plan.id;
      }
      return line;
    });
  }
  function firstUserError(r) { return (r && r.userErrors && r.userErrors[0]) ? r.userErrors[0].message : 'unknown'; }

  function handoff(address) {
    var nm = splitName(address.name);
    var cartId = null;
    var work = fetchThemeCart().then(function (tc) {
      if (!tc || !tc.items || !tc.items.length) throw new Error('empty-cart');
      var input = {
        lines: buildLines(tc.items),
        buyerIdentity: { phone: address.phone, countryCode: 'QA' },
        attributes: [{ key: '_source', value: 'web' }]
      };
      if (cfg.customer && cfg.customer.email) input.buyerIdentity.email = cfg.customer.email;
      var note = [tc.note, address.note].filter(Boolean).join('\n');
      if (note) input.note = note;
      return sf(Q_CART_CREATE, { input: input, lang: LANG });
    }).then(function (d) {
      var r = d.cartCreate;
      if (!r || (r.userErrors && r.userErrors.length) || !r.cart) throw new Error('cartCreate: ' + firstUserError(r));
      cartId = r.cart.id;
      var da = { firstName: nm.firstName, lastName: nm.lastName, address1: composeAddress1(address),
        city: address.city, countryCode: 'QA', phone: address.phone };
      return sf(Q_ADDR_ADD, { cartId: cartId, addresses: [{ address: { deliveryAddress: da }, selected: true, oneTimeUse: false }], lang: LANG });
    }).then(function (d) {
      var r = d.cartDeliveryAddressesAdd;
      if (!r || (r.userErrors && r.userErrors.length)) throw new Error('addrAdd: ' + firstUserError(r));
      return sf(Q_CART_READ, { id: cartId, lang: LANG });
    }).then(function (d) {
      var c = d.cart;
      if (!c || !c.checkoutUrl) throw new Error('verify: no-cart');
      if (!c.buyerIdentity || !c.buyerIdentity.phone) throw new Error('verify: phone');
      var sel = ((c.delivery && c.delivery.addresses) || []).filter(function (a) { return a.selected; });
      if (!sel.length) throw new Error('verify: address');
      try { localStorage.setItem(SFCART_KEY, JSON.stringify({ id: c.id, at: Date.now() })); } catch (e) {}
      return c.checkoutUrl;
    });
    return withTimeout(work, HANDOFF_TIMEOUT_MS);
  }

  /* ---------- checkout entry ---------- */
  var busy = false;
  var busyButton = null;
  function setBusy(button, on) {
    if (!button) return;
    if (on) { button.setAttribute('data-shop5-label', button.textContent); button.textContent = S.preparing || ''; button.disabled = true; }
    else { var l = button.getAttribute('data-shop5-label'); if (l !== null) button.textContent = l; button.disabled = false; }
  }
  function run(address, fallback, button) {
    if (busy) return;
    busy = true; busyButton = button; setBusy(button, true);
    handoff(address).then(function (url) { window.location.href = url; })
      .catch(function (err) {
        if (window.console) console.warn('[shop5-address] native checkout fallback:', err && err.message);
        busy = false; setBusy(button, false); fallback();
      });
  }
  /* WEB-03-B DFR-7: a page brought back from the back-forward cache must not keep checkout locked */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !busy) return;
    busy = false; setBusy(busyButton, false); busyButton = null;
  });
  function go(fallback, button, onCancel) {
    if (busy) return;
    var addr = currentAddress();
    if (addr) { run(addr, fallback, button); return; }
    modal = modal || $('[data-shop5-address-modal]');
    if (!modal) { fallback(); return; }
    openModal(function (saved) { run(saved, fallback, button); }, onCancel);
  }
  function nativeSubmit(form) {
    var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '';
    form.appendChild(i);
    HTMLFormElement.prototype.submit.call(form);
  }
  var lastCheckoutButton = null;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (b) lastCheckoutButton = b;
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form.cart-recap, form#mini-cart')) return;
    var submitter = e.submitter || lastCheckoutButton;
    if (!submitter || submitter.name !== 'checkout') return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(function () { nativeSubmit(form); }, submitter);
  }, true);

  /* ---------- modal ---------- */
  var modal, onSavedCb = null, onCancelCb = null, lastFocus = null;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function openModal(onSaved, onCancel) {
    modal = modal || $('[data-shop5-address-modal]');
    if (!modal) return;
    onSavedCb = onSaved || null;
    onCancelCb = onCancel || null;
    var a = readAddress() || customerAddress() || {};
    var c = cfg.customer || {};
    $('[name="s5name"]', modal).value = a.name || c.name || '';
    $('[name="s5phone"]', modal).value = a.phone ? phoneDigits(a.phone) : phoneDigits(c.phone || '');
    $('[name="s5city"]', modal).value = a.city || (S.cityPlaceholder || '');
    $('[name="s5zone"]', modal).value = a.zone || '';
    $('[name="s5street"]', modal).value = a.street || '';
    $('[name="s5building"]', modal).value = a.building || '';
    $('[name="s5note"]', modal).value = a.note || '';
    clearErrors();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('shop5-address-open');
    setTimeout(function () { var f = $('[name="s5name"]', modal); if (f) f.focus(); }, 30);
  }
  function closeModal(saved) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('shop5-address-open');
    var cancel = onCancelCb;
    onSavedCb = null; onCancelCb = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    if (!saved && cancel) cancel();
  }
  function setError(field, msg) {
    var el = $('[data-shop5-error="' + field + '"]', modal);
    if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    var input = $('[name="' + field + '"]', modal);
    if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }
  function clearErrors() { ['s5name', 's5phone', 's5city'].forEach(function (f) { setError(f, ''); }); }
  function saveFromModal() {
    clearErrors();
    var name = $('[name="s5name"]', modal).value.trim();
    var pd = phoneDigits($('[name="s5phone"]', modal).value);
    var city = $('[name="s5city"]', modal).value.trim();
    var ok = true;
    if (!name) { setError('s5name', S.errName); ok = false; }
    if (!pd) { setError('s5phone', S.errPhoneEmpty); ok = false; }
    else if (!isValidPhone(pd)) { setError('s5phone', S.errPhoneIncomplete); ok = false; }
    if (!city) { setError('s5city', S.errCity); ok = false; }
    if (!ok) return;
    var a = {
      name: name, phone: e164(pd), city: city,
      zone: digitsOnly($('[name="s5zone"]', modal).value, 3),
      street: digitsOnly($('[name="s5street"]', modal).value, 4),
      building: digitsOnly($('[name="s5building"]', modal).value, 4),
      note: $('[name="s5note"]', modal).value.slice(0, 500),
      savedAt: new Date().toISOString()
    };
    writeAddress(a);
    renderRows();
    var cb = onSavedCb;
    closeModal(true);
    if (cb) cb(a);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-shop5-address-edit]')) { e.preventDefault(); openModal(null); return; }
    if (t.closest('[data-shop5-address-close]')) { e.preventDefault(); closeModal(); return; }
    if (t.closest('[data-shop5-address-save]')) { e.preventDefault(); saveFromModal(); return; }
    if (modal && !modal.hidden && t === modal) { closeModal(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.name) return;
    if (t.name === 's5phone') t.value = digitsOnly(t.value, PHONE_DIGITS);
    if (t.name === 's5zone') t.value = digitsOnly(t.value, 3);
    if (t.name === 's5street' || t.name === 's5building') t.value = digitsOnly(t.value, 4);
  });

  /* ---------- saved-address rows ---------- */
  function summary(a) {
    var bits = [a.name, a.phone, [a.city, composeAddress1(a) !== a.city ? composeAddress1(a) : ''].filter(Boolean).join(', ')];
    return bits.filter(Boolean).join(' \u00B7 ');
  }
  function renderRows() {
    var a = currentAddress();
    var rows = document.querySelectorAll('[data-shop5-address-row]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!a) { row.hidden = true; continue; }
      var txt = row.querySelector('[data-shop5-address-text]');
      if (txt) txt.textContent = summary(a);
      row.hidden = false;
    }
  }
  document.addEventListener('cart:refresh', function () { setTimeout(renderRows, 300); });
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-shop5-address-row]') || n.querySelector('[data-shop5-address-row]'))) { renderRows(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- after a completed order: clear the theme cart ---------- */
  function checkCompleted() {
    var rec = null;
    try { rec = JSON.parse(localStorage.getItem(SFCART_KEY) || 'null'); } catch (e) {}
    if (!rec || !rec.id) return;
    if (!rec.at || Date.now() - rec.at > COMPLETION_WINDOW_MS) { try { localStorage.removeItem(SFCART_KEY); } catch (e) {} return; }
    sf(Q_CART_READ, { id: rec.id, lang: LANG }).then(function (d) {
      if (d && d.cart) return;
      try { localStorage.removeItem(SFCART_KEY); } catch (e) {}
      return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
    }).catch(function () {});
  }

  window.shop5Checkout = { go: go, openAddress: function () { openModal(null); }, refreshRows: renderRows };
  function init() { renderRows(); checkCompleted(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
